import type { CustomNextRouter } from 'src/shared/lib/history/types';

import { sortingQueryToApiMap } from './maps';

type QueryValue = string | string[] | undefined;

const toArray = (value?: QueryValue) => {
  if (!value) {
    return [];
  }

  const arr = Array.isArray(value)
    ? value
    : [value];

  return arr
    .flatMap((item) => item.split(','))
    .map((item) => item.trim())
    .filter(Boolean);
};

export const hasPsychicSortingQueryParams = (query: Record<string, any> | undefined | null) => {
  if (!query) {
    return false;
  }

  return Object.keys(query).some((key) => key.toLowerCase().startsWith('ps_'));
};

export const mapPsychicSortingFromQuery = (router: CustomNextRouter) => {
  const { query } = router;

  if (!query || !Object.keys(query).length || !router.asPath.includes('?')) {
    return {};
  }

  const rawValues = toArray(query.ps_sort as QueryValue);

  if (!rawValues.length) {
    return {};
  }

  const sortedValue = sortingQueryToApiMap[rawValues[0]];

  return { selectedSortItem: { SortBy: sortedValue } };
};
